// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer[data-v-44a7ff9f]{justify-content:center}.data-table__pre-header[data-v-44a7ff9f]{border-bottom:1px solid var(--pale-sky-blue)}#titleAndSearch .titleAndSearch__title[data-v-44a7ff9f]{font-size:1.375rem}@media(max-width:960px){#titleAndSearch .v-col[data-v-44a7ff9f]{flex-direction:column;align-items:flex-start}#titleAndSearch .v-text-field[data-v-44a7ff9f]{width:100%}#titleAndSearch .v-btn[data-v-44a7ff9f]{margin-top:10px}}", ""]);
// Exports
module.exports = exports;
